import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MultiSelectPicker from './components/MultiSelectPicker/MultiSelectPicker';


ReactDOM.render(
  <React.StrictMode>
    <MultiSelectPicker options={['Budget', 'Food allergies', 'Number of people', 'Special restrictions']}/>
  </React.StrictMode>,
  document.getElementById('root')
);
